// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"519fc8fd","183":"225bb1a1","686":"c990395d","702":"3bee258c","914":"89be5aa6"}[chunkId] + ".chunk.js";
};